/**
 * Basket source filter (the Gmail / Outlook / Checklist / Other tag dropdown)
 * — pure logic, worker/jest-safe: no DOM, no Angular, no service imports.
 *
 * Semantics: an EMPTY selection means "no filtering". Types outside
 * gmail/outlook/checklist bucket under 'other'. The system connect-email card
 * is never filtered away.
 */

export interface SourceFilterable {
    particleType?: string;
}

export const SOURCE_FILTER_OPTIONS: ReadonlyArray<{ key: string; label: string; icon: string }> = [
    { key: 'gmail', label: 'Gmail', icon: 'mail' },
    { key: 'outlook', label: 'Outlook', icon: 'alternate_email' },
    { key: 'checklist', label: 'Checklist', icon: 'checklist' },
    { key: 'other', label: 'Other', icon: 'category' },
];

export function filterParticlesBySource<T extends SourceFilterable>(
    particles: T[],
    active: ReadonlySet<string>
): T[] {
    return particles.filter((p) => {
        const t = (p?.particleType || '').toLowerCase();
        if (t === 'system') return true; // connect-email card is never filtered away
        const bucket = t === 'gmail' || t === 'outlook' || t === 'checklist' ? t : 'other';
        return active.has(bucket);
    });
}
